import { Injectable } from '@angular/core'
import { Observable, Subject } from 'rxjs'

/** Identifies a dropdown group on the home dashboard for mutual exclusion. */
export const HOME_DROPDOWN_SOURCE = {
    MONTHLY_LEADERBOARD: 'monthly-leaderboard',
    DEALS_PIPELINE: 'deals-pipeline',
    NEW_LEADS_FILTERS: 'new-leads-filters',
} as const

@Injectable({ providedIn: 'root' })
export class HomeDashboardDropdownCoordinatorService {
    private readonly openedSource = new Subject<string>()

    /** Other sections subscribe and close when a different source opens. */
    readonly opened$: Observable<string> = this.openedSource.asObservable()

    notifyOpened(sourceId: string): void {
        this.openedSource.next(sourceId)
    }
}
